import React, { Fragment } from 'react';
import { CheckIcon } from 'lucide-react';
export interface ProgressStepperProps {
  currentStep: 1 | 2 | 3;
  steps: string[];
}
export function ProgressStepper({
  currentStep,
  steps
}: ProgressStepperProps) {
  return <div className="w-full flex items-center justify-between px-4" data-id="element-1666">
      {steps.map((step, index) => {
      const stepNumber = index + 1;
      const isComplete = stepNumber < currentStep;
      const isCurrent = stepNumber === currentStep;
      return <Fragment key={step} data-id="element-1667">
            <div className="flex flex-col items-center gap-2.5 flex-1" data-id="element-1668">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300 ${isComplete ? 'bg-[#4DB8C4] text-white shadow-md' : isCurrent ? 'bg-[#4DB8C4] text-white shadow-lg ring-4 ring-[#4DB8C4]/20' : 'bg-gray-200 text-gray-400'}`} data-id="element-1669">
                {isComplete ? <CheckIcon className="w-6 h-6" strokeWidth={3} data-id="element-1670" /> : stepNumber}
              </div>
              <span className={`text-sm font-medium transition-colors ${isCurrent ? 'text-gray-900' : 'text-gray-500'}`} data-id="element-1671">
                {step}
              </span>
            </div>

            {index < steps.length - 1 && <div className="flex-1 max-w-[120px] mb-8" data-id="element-1672">
                <div className={`h-1 rounded-full transition-all duration-300 ${stepNumber < currentStep ? 'bg-[#4DB8C4]' : 'bg-gray-200'}`} data-id="element-1673" />
              </div>}
          </Fragment>;
    })}
    </div>;
}